export default __webpack_public_path__ + "static/media/target.6f7b303b.svg";